// @flow
import { set } from 'lodash';

type ResponseData = { objects?: Array<{}>, results?: Array<{}> };

const makeTypeResponse = (accessorKey: string) => (typename: string) => (
  data: ResponseData
) => {
  if (data[accessorKey]) {
    data[accessorKey] = data[accessorKey].map(object => ({
      ...object,
      __typename: typename,
    }));
  }
  return data;
};

export const typeObjects = makeTypeResponse('objects');
export const typeResults = makeTypeResponse('results');

const typePatcher = {
  FoldersPayload: typeObjects('Folder'),
  DeveloperPayload: typeResults('Developer'),
  PartnerSettingsPayload: typeObjects('PartnerSettings'),
  PublicSharedZap: (data: {}): any => {
    set(data, ['creator', '__typename'], 'Creator');
    set(data, ['guidedRecipe', '__typename'], 'GuidedRecipe');
    set(data, ['guidedRecipe', 'headService', '__typename'], 'HeadService');
    set(data, ['guidedRecipe', 'tailService', '__typename'], 'TailService');
    return data;
  },
};

export default typePatcher;
